export default __webpack_public_path__ + "static/media/eye-off.dcb347f3.svg";